export default {
    defaults: [
        {
            domain: 'actors.mandy',
            detailed: false
        },
        {
            domain: 'voiceovers.mandy',
            detailed: true,
            contentType: 'mediaFiles'
        },
        {
            domain: 'kids.mandy',
            detailed: false
        },
        {
            domain: 'singers.mandy',
            detailed: true,
            contentType: 'mediaFiles'
        },
        {
            domain: 'dancers.mandy',
            detailed: false
        },
        {
            domain: 'talent.mandy',
            detailed: false
        },
        {
            domain: 'crew.mandy',
            detailed: true,
            contentType: 'credits'
        },
        {
            domain: 'stage.mandy',
            detailed: true,
            contentType: 'credits'
        },
        {
            domain: 'music.mandy',
            detailed: true,
            contentType: 'credits'
        }
    ],

    detailed(domain, likeSearch = false) {
        let config = this.defaults.find(defaultConf => (defaultConf.domain === domain || (likeSearch && domain.indexOf(defaultConf.domain) !== -1)));
        return config ? config.detailed : null;
    },

    contentType(domain, likeSearch = false) {
        if (this.detailed(domain)) {
            let config = this.defaults.find(defaultConf => (defaultConf.domain === domain || (likeSearch && domain.indexOf(defaultConf.domain) !== -1)));
            return config ? config.contentType : null;
        }
        return null;
    }
}